import {
  TypedUseSelectorHook,
  useSelector as useReduxSelector,
} from 'react-redux'
import logger from 'redux-logger'
import { persistStore } from 'redux-persist'
import createSagaMiddleware from 'redux-saga'

import createStore from './createStore'
import persistReducers from './persistReducers'

import rootReducer from './modules/rootReducer'
import rootSaga from './modules/rootSaga'

const sagaMiddleware = createSagaMiddleware({})

const middlewares = [sagaMiddleware, logger]

const store = createStore(persistReducers(rootReducer), middlewares)
const persistor = persistStore(store)

sagaMiddleware.run(rootSaga)

export { store, persistor }

export const useSelector: TypedUseSelectorHook<ReturnType<
  typeof rootReducer
>> = useReduxSelector
